import { get, post } from 'api';
import { cleanObject } from 'utils/object';

import {
  LOAD_ORDER,
  LOAD_ORDERS,
  LOAD_ORDER_DETAILS,
  ORDERS_FAILED,
  ORDERS_LOADED,
  ORDER_DETAILS_FAILED,
  ORDER_DETAILS_LOADED,
  ORDER_FAILED,
  ORDER_LOADED,
  ORDER_SAVED,
  RESET_ORDERS,
  SAVE_ORDER,
  SAVE_ORDER_ERROR,
} from './actionTypes';
import type { ILoadOrdersParams } from './types';

export const initialActionsState = {
  loadOrder: () => {},
  loadOrderDetails: () => {},
  loadOrders: () => {},
  saveOrder: () => {},
  resetOrders: () => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => ({
  loadOrder: async (orderId: string) => {
    dispatch({
      type: LOAD_ORDER,
    });

    const { data, error } = await get(`/cp/orders/${orderId}`);

    if (data && !error) {
      dispatch({
        type: ORDER_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: ORDER_FAILED,
        payload: error,
      });
    }
  },
  loadOrderDetails: async (customerReference: string) => {
    dispatch({
      type: LOAD_ORDER_DETAILS,
    });

    const { data, error } = await get(`/cp/customer-order-details/${customerReference}`);

    if (data && !error) {
      dispatch({
        type: ORDER_DETAILS_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: ORDER_DETAILS_FAILED,
        payload: error,
      });
    }
  },

  loadOrders: async (customerReference: string, params: ILoadOrdersParams) => {
    dispatch({
      type: LOAD_ORDERS,
    });

    const { data, error } = await get(`/cp/customer-orders/${customerReference}`, {
      params: cleanObject(params),
    });

    if (!error) {
      dispatch({
        type: ORDERS_LOADED,
        payload: Array.isArray(data) ? data : [],
      });
    } else {
      dispatch({
        type: ORDERS_FAILED,
        payload: error,
      });
    }
  },
  saveOrder: async (order, onSuccess, onError) => {
    dispatch({
      type: SAVE_ORDER,
    });

    const { error } = await post('/cp/save-order', order);

    if (!error) {
      dispatch({
        type: ORDER_SAVED,
      });
      if (onSuccess) onSuccess();
    } else {
      if (onError) onError(error);
      dispatch({
        type: SAVE_ORDER_ERROR,
        payload: error,
      });
    }
  },

  resetOrders: () =>
    dispatch({
      type: RESET_ORDERS,
    }),
});
